// External-Dependencies
import { isUndefined, pickBy } from 'lodash';

// WP-Dependencies
import { Component } from '@wordpress/element';
import { PanelBody, QueryControls } from '@wordpress/components';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';
// import { __ } from '@wordpress/i18n';
// import { dateI18n, format, __experimentalGetSettings } from '@wordpress/date';
import { InspectorControls } from '@wordpress/block-editor';
import { withSelect } from '@wordpress/data';
import { decodeEntities } from '@wordpress/html-entities';

//Constants
import {
	MIN_EXCERPT_LENGTH,
	MAX_EXCERPT_LENGTH,
	MAX_POSTS_COLUMNS,
} from './constants';


export default withSelect( ( select, props ) => {
	

	const {
		category,
		date,
	} = props.attributes;
	
        return { 
		cat: select('core/editor').getEditedPostAttribute( 'categories' ),
		dat: select('core/editor').getEditedPostAttribute( 'date' ),
	 };

})( function( props ) {
	
        const {
		attributes,
		setAttributes,
	} = props;
        
        
	const smBEditorStyleUl = {
	    display:"flex",
	    // float: "left",
	    listStyle: "none",
	    marginLeft: "0",
	    paddingLeft: "0",
	};

	const smBEditorStyleLi = {
		// float: "left",
		marginLeft: "10px",
		padding: "5px",
		backgroundColor: "#da1f3d",
		color: "#fff"
	};
        
        var txtDecoder = document.createElement("textarea");
        
        wp.apiFetch( { path: '/wp/v2/categories/'+ props.cat[0] } ).then( category => {
            txtDecoder.innerHTML = category.name;
            setAttributes({'category': txtDecoder.value});
        });
        
        var date = new Date(props.dat);
        var dateFormated = new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit',}).format(date);
        
        setAttributes({'date': dateFormated});
        
        return(
                <>
                    <p class="gtue-news-header">
                        <span class="gtue-news-header-cat">{props.attributes.category}</span>
                        <span class="gtue-news-header-date">{props.attributes.date}</span>
                    </p>
                </>

        );

});



